import { Button } from "@material-ui/core";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import { Keyboard } from "@material-ui/icons";
import * as React from "react";
import { buttonOffset } from "src/pages/home/Home";
import Component from "./Component";
import { AppContextConsumer, IAppContext } from "./withAppContext";
import withAxios, { IAxiosProps } from "./withAxios";
import { Link } from "react-router-dom";

const styles = () => ({
  text: {
    color: "white",
  },
});

interface ILoginFormState {
  error: boolean;
  submitting: boolean;
}

type IProps = IAppContext &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

const SignUpForm = withStyles(styles)(
  withAxios(
    class extends Component<IProps, ILoginFormState> {
      public readonly state: Readonly<ILoginFormState> = {
        error: false,
        submitting: false,
      };

      public render() {
        return this.renderGoogleButton()
      }

      private renderGoogleButton = () => {
        return (

          <Link to="/sign-up">
            <Button
              variant="contained"
              color="primary"
              // onClick={this.handleGoogleClick}
              style={{ marginLeft: buttonOffset }}
              startIcon={<Keyboard />}
            >
             {/* Sign Up to your account */}
             Create an Account
             {/* Sign Up to Start */}
            </Button>
          </Link>

        );
      };

      //       private handleGoogleClick = () =>
      //         void this.runCancellableStatefulAsync(
      //           this,
      //           {
      //             error: false,
      //             submitting: true,
      //           },
      //           {
      //             submitting: false,
      //           },
      //           async () => {
      //             const response = await this.buildGet<ILogin>(
      //               this,
      //               "login/google"
      //             )();
      //             location.href = response.url;
      //           },
      //           () => {
      //             this.setState({
      //               error: true,
      //               submitting: false,
      //             });
      //           }
      //         );

      // \
    }
  )
);

export default () => (
  <AppContextConsumer>
    {(context) => <SignUpForm {...context} />}
  </AppContextConsumer>
);



// WEBPACK FOOTER //
// ./src/components/SignUpForm.tsx